import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import BrandDivider from '../BrandDivider';

const NavCard = ({ link, cardImage, image, header, title, description }) => {
  if (!link?.link) return null;
  const linkObj = buildLinkObj(link);
  const imgUrl = buildImageSrc(image || cardImage, 800, 2, 1);

  return (
    <li className="tw-flex-1 md:tw-mx-4 tw-mb-4 md:tw-mb-0 tw-text-center tw-bg-white tw-border tw-border-warm-100">
      <div role="group" aria-label="item">
        <LazyLoadImage imgComponent={<img src={imgUrl} alt="" className="tw-max-w-full" />} />
        <div className="tw-flex-1 tw-flex tw-flex-col tw-p-4">
          {header && <p className="tra-text-web-sub-2 tw-mb-2">{header}</p>}
          {title && <h2 className="tra-text-web-heading-h5">{title}</h2>}
          <BrandDivider />
          {description && (
            <p className="tw-body2 tw-mt-4 tw-flex-1 hover:tw-text-neutral-800">{description}</p>
          )}
          <a rel={getRel(linkObj)} href={linkObj.href} className="tw-flex tw-flex-col tw-h-full">
            <span className="tw-body2 tw-mt-6 tw-underline">{link.displayName}</span>
          </a>
        </div>
      </div>
    </li>
  );
};

export default NavCard;
